<template>
  <div style="position: relative; min-height: 100%; background-color: var(--bgColorHome); vertical-align: bottom;">
    <img :src="infoLink" style="width: 100%;" />
    <img class="returnButton" :src="returnButtonLink" v-on:click="backToHome" />
  </div>
</template>

<script>
  export default {
    name: 'imagesInfo',
    computed: {
      infoLink: function(){
        return infoLinkConfig.info[this.$route.params.index];
      },
      returnButtonLink: function(){
        return commonLinkConfig.returnButton;
      }
    },
    methods: {
      backToHome: function(){
        this.$router.go(-1);
      }
    }
  }
</script>

<style scoped>
  .returnButton {
    display: block;
    position: absolute;
    width: 18%;
    top:20px;
    right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/imagesInfo.vue